import React from "react";
import "./ReturnAndRefundPolicy.css";

const ReturnAndRefundPolicy = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  return (
    <div>
      <h1>This is return page</h1>
    </div>
  );
};

export default ReturnAndRefundPolicy;
